<template>
  <div style="width: 100%; height: 100%;pointer-events:all">
    <!-- <iframe
      style="width: 100%; height: 100%"
      src="http://60.167.58.22:18081/cosv/views/index.html"
      frameborder="0"
    ></iframe> -->

    <iframe
      style="width: 100%; height: 100%"
      src="http://cosv.cfcm.zkhfzhnyg.cn/views/index.html"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: 'SaleIndex',
  components: {},
  data() {
    return {}
  },
  mounted() {
    console.log('【↑↑↑】', this.$options.name)
  },
  beforeDestroy() {
    console.log('【↓↓↓】', this.$options.name)
  },
}
</script>


<style scoped >
</style>

<style>
</style>



// WEBPACK FOOTER //
// src/components/sale/Index.vue